module.exports = __webpack_public_path__ + "static/media/sarias-song.63b1b4a.mid";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sarias-song.mid
// module id = 1LlO
// module chunks = 0